import EnterGoal from './EnterGoal'

export default EnterGoal
